import { sourceArchive } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function SourceArchive() {
  return (
    <section id="sources" className="w-full border-y border-background-200/80 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-6">
        <SectionHeading
          eyebrow="来源归档"
          title="同一来源的内容集中列出，方便比对与补充"
          desc="按来源建档案后，同一份出处的条目排在一起，去看差异、查缺补漏都比到处翻更快。"
          linkLabel="查看来源说明"
          linkHref="#download"
        />

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {sourceArchive.map((source) => (
            <a
              key={source.name}
              href="#collections"
              className="group flex flex-col rounded-lg border border-background-200/80 bg-background-50 p-4 transition-colors hover:border-secondary-300 cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                  <i className={`${source.icon} text-lg`} />
                </span>
                <span className="font-label text-lg font-semibold text-foreground-900">
                  {source.count}
                </span>
              </div>
              <h3 className="mt-3.5 text-sm font-medium text-foreground-950 transition-colors group-hover:text-secondary-800">
                {source.name}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">{source.category}</p>
              <div className="mt-3 flex items-center gap-1 text-[11px] text-foreground-400">
                <span>进入来源档案</span>
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}